module.exports = __webpack_public_path__ + "static/media/calendar.5d820edd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePicker/calendar.svg
// module id = 1212
// module chunks = 0